import { Modal, Row, Col } from 'antd';
import { CustomButton, CustomTable, CustomTextArea } from '../../../../components';
import { Evaluation } from '../../types/evaluations-types';
import { EyeOutlined } from '@ant-design/icons';
interface ModalShowEvaluationProps {
  setIsModalAddItem: (value: boolean) => void;
  isModalAddItem: boolean;
  selectedItem: Evaluation | null;
}

const ModalShowEvaluation = ({
  setIsModalAddItem,
  isModalAddItem,
  selectedItem,
}: ModalShowEvaluationProps) => {

  const columnsEvaluation = [
    {
      title: 'Código',
      dataIndex: 'id',
      key: 'id'
    },
    {
      title: 'Lista predefinida',
      dataIndex: 'predefined_list',
      key: 'predefined_list',
    },
    {
      title: 'Característica o aspecto',
      dataIndex: 'predefined_list_aspect',
      key: 'predefined_list_aspect',
    },
    {
      title: 'Descripción de la revisión',
      dataIndex: 'predefined_list_description',
      key: 'predefined_list_description',
    },
    {
      title: 'Estado',
      dataIndex: 'status',
      key: 'status',
    },
  ]
    const columenEvidenceEvaluation = [
    {
      title: 'Ítem',
      dataIndex: 'id',
      key: 'id'
    },
    {
      title: 'Nombre',
      dataIndex: 'name',
      key: 'name',
    },
     {
      title: 'Acciones',
      key: 'acciones',
      render: (_:any, record:any) => (
        <a href={record.url} target="_blank" rel="noopener noreferrer">
          <EyeOutlined />
        </a>
      ),
    }
  ];

  const evidenceEvaluationDataSource = selectedItem
  ? selectedItem.documents.map(doc => ({
      key: doc.id,
      id: doc.id,
      name: doc.name,
      url: doc.url
    }))
  : [];

  const evaluationDataSource = selectedItem
  ? [{ ...selectedItem, key: selectedItem.id }]
  : [];

  if (!selectedItem) return null;

  return (
    <Modal
      width={'95vw'}
      title="Evaluación técnica"
      open={isModalAddItem}
      onCancel={() => setIsModalAddItem(false)}
      footer={[
        <CustomButton
          key="finish"
          label="Finalizar"
          onClick={() => setIsModalAddItem(false)}
        />
      ]}
    >
      <Row>
        <Col xs={24}>
          <CustomTable
            columns={columnsEvaluation}
            dataSource={evaluationDataSource}
            pagination={{ pageSize: 5 }}
            scroll={{ x: 'max-content' }} />
        </Col>
      </Row>
      <Col span={24}>
        <CustomTextArea
          label="Observaciones"
          name="observations"
          value={selectedItem.observations ?? ''}
          placeholder="Observaciones"
          error=""
          disabled
        />
      </Col>
      <Row>
        <Col xs={24}>
        <h4>Evidencia de la evaluación</h4>
          <CustomTable
            columns={columenEvidenceEvaluation}
            dataSource={evidenceEvaluationDataSource}
            pagination={{ pageSize: 5 }}
            scroll={{ x: 'max-content' }} />
        </Col>
      </Row>
    </Modal>
  );
};

export default ModalShowEvaluation;